import { PATHS } from '../paths'

export const excludePresidentCardPath: string[] = [
  PATHS.SETTINGS_IDENTIFICATION,
  PATHS.SETTINGS_SLACK_NOTIFICATION,
  PATHS.SETTINGS_TEAMS_NOTIFICATION,
  PATHS.SETTINGS_SSO,
  PATHS.SETTINGS_ACCOUNTING_INTEGRATION_EDIT,
  PATHS.SETTINGS_ACCOUNTING_TRANSACTION_END_DATE,
  PATHS.SETTINGS_ACCOUNTING_JOURNAL_START_DATE,
  PATHS.SETTINGS_ACCOUNTING_POINT_ACCOUNT_EDIT,
  PATHS.CARDS_ISSUE_PHYSICAL_ISSUANCE_REQUESTS,
  PATHS.USER_CARDS_ISSUE_PHYSICAL_ISSUANCE_REQUESTS,
]
